import React, { FC, useCallback, useRef } from 'react';
import { uploadImageFile } from '@utils/uploadImage';
import { OliveYoungOnlyBuyModuleFormType } from '@container/Challenge/NewChallengeForm/NewChallengeForm.types';
import Label from '@component/Label';
import FlexBox from '@component/FlexBox/FlexBox';
import TextArea from '@component/TextArea';
import Button from '@component/Button';
import { ModuleContainer } from '../../../../DescriptionModuleForm.style';

type ReviewInfoType = Pick<
  OliveYoungOnlyBuyModuleFormType,
  'reviewGuide' | 'reviewExampleImageUrls' | 'reviewSubGuide'
>;
type Props = {
  data: ReviewInfoType;
  onChange: (data: ReviewInfoType) => void;
};
const ReviewInfoForm: FC<Props> = ({ data, onChange }) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleChangeReviewGuide = useCallback(
    (text: string) => {
      onChange({ ...data, reviewGuide: text });
    },
    [data, onChange],
  );

  const handleChangeReviewSubGuide = useCallback(
    (text: string) => {
      onChange({ ...data, reviewSubGuide: text });
    },
    [data, onChange],
  );

  const handleAddReviewImage = async (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const files = e.target.files ? Array.from(e.target.files) : [];

    const urls = await Promise.all(files.map((f) => uploadImageFile(f)));
    onChange({
      ...data,
      reviewExampleImageUrls: [...data.reviewExampleImageUrls, ...urls],
    });
    if (inputRef.current) {
      inputRef.current.value = '';
    }
  };

  const handleRemoveReviewImage = (index: number) => {
    onChange({
      ...data,
      reviewExampleImageUrls: data.reviewExampleImageUrls.filter(
        (_, i) => i !== index,
      ),
    });
  };

  return (
    <ModuleContainer>
      <Label size="large" style={{ marginTop: 20, marginBottom: 20 }}>
        리뷰 정보
      </Label>
      <FlexBox.Row gap={8} alignItems="center">
        <Label style={{ width: 100 }}>리뷰 안내 가이드</Label>
        <TextArea
          value={data.reviewGuide}
          onChange={handleChangeReviewGuide}
          containerStyle={{ flex: 1 }}
        />
      </FlexBox.Row>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',

          marginBottom: 16,
        }}
      >
        (안내 가이드에서 강조하고 싶은 부분은 반드시 양쪽을 &apos;&apos;로
        묶어주세요)
      </div>

      <FlexBox.Row gap={8} alignItems="center">
        <Label style={{ width: 100 }}>리뷰 가이드 예시</Label>
        <TextArea
          value={data.reviewSubGuide}
          onChange={handleChangeReviewSubGuide}
          containerStyle={{ flex: 1 }}
        />
      </FlexBox.Row>

      <FlexBox.Row gap={8} alignItems="center" style={{ marginTop: 12 }}>
        <Label style={{ width: 150 }}>리뷰 예시 이미지</Label>
        <Button text="추가" onClick={() => inputRef.current?.click()} />
      </FlexBox.Row>
      <input
        ref={inputRef}
        type="file"
        style={{ display: 'none' }}
        multiple
        onChange={handleAddReviewImage}
      />
      <FlexBox.Row gap={12}>
        {data.reviewExampleImageUrls.map((url, index) => (
          <FlexBox.Column style={{ width: 120 }} key={url}>
            <img
              src={url}
              style={{ width: '100%', aspectRatio: 1 }}
              alt={`리뷰 이미지 ${index}`}
            />
            <Button
              text="삭제"
              onClick={() => handleRemoveReviewImage(index)}
            />
          </FlexBox.Column>
        ))}
      </FlexBox.Row>
    </ModuleContainer>
  );
};

export default ReviewInfoForm;
